export const config = {
  data() {
    return {
      columns: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center'
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          minWidth: 230
        },
        {
          title: '标题',
          key: 'title',
          align: 'center',
          minWidth: 200,
          render(h, params) {
            let text = params.row.title;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true, maxWidth: 220 }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text
                ),
                h('span', { slot: 'content' }, text)
              ]
            );
          }
        },
        {
          title: '保司',
          key: 'companyName',
          align: 'center',
          minWidth: 160
        },
        {
          title: '销售状态',
          key: 'salesStatus',
          align: 'center',
          width: 100,
          render(h, params) {
            const value = params.row.salesStatus == 2 ? '在售' : '停售';
            return <div>{value}</div>;
          }
        },
        {
          title: '上架状态',
          slot: 'publishStatus',
          align: 'center',
          width: 100,
          renderHeader: (h, params) => {
            return (
              <div>
                <span>上架状态</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>是：业务员展业APP显示此产品</p>
                    <p>否：业务员展业APP不显示此产品</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '总份额',
          key: 'totalGiftNum',
          align: 'center',
          width: 110
        },
        {
          title: '可用份额',
          key: 'remainGiftNum',
          align: 'center',
          width: 110
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 190,
          fixed: 'right'
        }
      ]
    };
  }
};
